<script>
   import { onMount } from 'svelte';
   import { fade } from 'svelte/transition';

   const jq = window.$

   export let slides = [1, 2, 3, 4]

   let activeIdx = 0
   onMount(() => {
      // setInterval(() => {
      //    activeIdx = (activeIdx + 1)%(slides.length)
      //    console.log(activeIdx)
      // }, 4000)
      window.$('.code-inner').slick({
         arrows: true,
         appendArrows: '#slick-arrows-wrap',
         prevArrow: '<button type="button" class="slick-prev"><span aria-label="previous"> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9393 23.5607C11.5251 24.1464 12.4749 24.1464 13.0607 23.5607C13.6464 22.9749 13.6464 22.0251 13.0607 21.4393L5.12132 13.5L22.5 13.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5L5.12132 10.5L13.0607 2.56066C13.6464 1.97487 13.6464 1.02512 13.0607 0.43934C12.4749 -0.146449 11.5251 -0.146449 10.9393 0.43934L0.439342 10.9393C-0.146445 11.5251 -0.146445 12.4749 0.439342 13.0607L10.9393 23.5607Z" fill="white"/> </svg> </span> </button>',
         nextArrow: '<button type="button" class="slick-next"><span aria-label="next"> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0607 0.439342C12.4749 -0.146445 11.5251 -0.146445 10.9393 0.439341C10.3536 1.02513 10.3536 1.97488 10.9393 2.56066L18.8787 10.5L1.5 10.5C0.671571 10.5 -2.44162e-06 11.1716 -2.62268e-06 12C-2.80374e-06 12.8284 0.67157 13.5 1.5 13.5L18.8787 13.5L10.9393 21.4393C10.3535 22.0251 10.3535 22.9749 10.9393 23.5607C11.5251 24.1464 12.4749 24.1464 13.0607 23.5607L23.5607 13.0607C24.1464 12.4749 24.1464 11.5251 23.5607 10.9393L13.0607 0.439342Z" fill="white"/> </svg> </span> </button>',
         appendDots: '#ps-nav-custom',
         // autoplay: 5000,
         dots: true,
         fade: true,
         infinite: true,
         //   speed: 300,
         slidesToShow: 1,
         slidesToScroll: 1,
         // adaptiveHeight: true
      })
   })
</script>


<div class="code-outer">
   <div class="code-inner">
      {#each slides as slide, idx}
         <!-- {#if activeIdx == idx} -->
            <div class="pslide d-flex flex-column flex-md-row" class:xhidden={activeIdx != idx}>
               <!-- <div transition:fade="{{duration: 350}}" class="dimg" style="background-image: url({slide.image ? slide.image.sizes.large : ""})"></div> -->
               <!-- in:fade="{{duration: 250}}" out:fade="{{duration: 350}}" -->
               {#if slide.image}
                  <!-- <div class="decor-img" style='background-image: url({slide.image.sizes['2048x2048']})'></div> -->
                  <img class="decor-img" src='{slide.image.sizes['2048x2048']}' alt="" />
               {:else}
                  <div class="decor-img"></div>
               {/if}
               <div class="port-slide-content">
                  {@html slide.content}
               </div>
            </div>
         <!-- {/if} -->
      {/each}
      <!-- <div id="ps-nav-custom" class="owl-nav-custom">
         <div class="owl-dots">
            <!-- TODO - Buttons do not have an accessible name -- >
            {#each slides as slide, idx}
               <div role="button" class="owl-dot" class:active={activeIdx == idx} data-idx="{idx}" on:click={() => activeIdx  = idx}>
                  <span class="sr-only">go to slide {idx}</span>
               </div>
            {/each}
         </div>
         <div class="owl-nav">
            <button type="button" role="presentation" class="owl-prev" on:click={() => {
               activeIdx -= 1
               if(activeIdx < 0) {
                  activeIdx = slides.length - 1
               }
               }}>
               <span aria-label="previous">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9393 23.5607C11.5251 24.1464 12.4749 24.1464 13.0607 23.5607C13.6464 22.9749 13.6464 22.0251 13.0607 21.4393L5.12132 13.5L22.5 13.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5L5.12132 10.5L13.0607 2.56066C13.6464 1.97487 13.6464 1.02512 13.0607 0.43934C12.4749 -0.146449 11.5251 -0.146449 10.9393 0.43934L0.439342 10.9393C-0.146445 11.5251 -0.146445 12.4749 0.439342 13.0607L10.9393 23.5607Z" fill="white"/> </svg>
               </span>
            </button>
            <button type="button" role="presentation" class="owl-next" on:click={() => {
               activeIdx += 1
               if(activeIdx > slides.length - 1) {
                  activeIdx = 0
               }
               }}>
               <span aria-label="Next">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0607 0.439342C12.4749 -0.146445 11.5251 -0.146445 10.9393 0.439341C10.3536 1.02513 10.3536 1.97488 10.9393 2.56066L18.8787 10.5L1.5 10.5C0.671571 10.5 -2.44162e-06 11.1716 -2.62268e-06 12C-2.80374e-06 12.8284 0.67157 13.5 1.5 13.5L18.8787 13.5L10.9393 21.4393C10.3535 22.0251 10.3535 22.9749 10.9393 23.5607C11.5251 24.1464 12.4749 24.1464 13.0607 23.5607L23.5607 13.0607C24.1464 12.4749 24.1464 11.5251 23.5607 10.9393L13.0607 0.439342Z" fill="white"/> </svg>
               </span>
            </button>
         </div>
      </div> -->
   </div>
   <div id="ps-nav-custom" class="owl-nav-custom">
      <div id="slick-arrows-wrap"></div>
   </div>
</div>